export const DESCRIPTION_INFO = 'DESCRIPTION_INFO';
export const AVAILABILITY_INFO = 'AVAILABILITY_INFO';
export const DELIVERY_INFO = 'DELIVERY_INFO';
export const REVIEW_INFO = 'REVIEW_INFO';

export const DESCRIPTION_INFO_DATA = {
  key: 'description',
  name: 'Описание',
};
export const AVAILABILITY_INFO_DATA = {
  key: 'availability',
  name: 'Наличие в магазинах',
};
export const DELIVERY_INFO_DATA = {
  key: 'delivery',
  name: 'Доставка и возврат',
};
export const REVIEW_INFO_DATA = {
  key: 'review',
  name: 'Отзывы',
  ratingGetter: 'product/reviewRating',
  counterGetter: 'product/reviewsСount',
};

export const CONFIG = {
  [DESCRIPTION_INFO]: DESCRIPTION_INFO_DATA,
  [AVAILABILITY_INFO]: AVAILABILITY_INFO_DATA,
  [DELIVERY_INFO]: DELIVERY_INFO_DATA,
  [REVIEW_INFO]: REVIEW_INFO_DATA,
}

export default [DESCRIPTION_INFO_DATA, AVAILABILITY_INFO_DATA, DELIVERY_INFO_DATA, REVIEW_INFO_DATA];
